(function () {
  function buildArrow(dir, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'avb-gallery-arrow avb-gallery-arrow--' + (dir > 0 ? 'next' : 'prev');
    btn.setAttribute('aria-label', label);
    btn.innerHTML = dir > 0
      ? '<svg viewBox="0 0 24 24" width="36" height="36" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 24 24" width="36" height="36" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return btn;
  }

  function initGallery(gallery) {
    if (gallery.dataset.avbArrows === 'true') return;
    var mediaList = gallery.querySelector('.product__media-list');
    if (!mediaList) return;
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;
    gallery.dataset.avbArrows = 'true';

    function go(direction) {
      var current = gallery.querySelector('.product__media-item.is-active') || items[0];
      var idx = items.indexOf(current);
      if (idx < 0) idx = 0;
      var targetIdx = (idx + direction + items.length) % items.length;
      var mediaId = items[targetIdx].dataset.mediaId;
      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId);
      } else {
        var thumbs = gallery.querySelectorAll('button.thumbnail');
        if (thumbs[targetIdx]) thumbs[targetIdx].click();
      }
    }

    var prev = buildArrow(-1, 'Vorheriges Bild');
    var next = buildArrow(1, 'Nächstes Bild');
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    gallery.appendChild(prev);
    gallery.appendChild(next);

    function positionArrows() {
      var top = mediaList.offsetTop + mediaList.offsetHeight / 2;
      prev.style.top = top + 'px';
      next.style.top = top + 'px';
    }
    positionArrows();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(positionArrows).observe(mediaList);
    }
    window.addEventListener('resize', positionArrows);
  }

  function initAll(root) {
    (root || document).querySelectorAll('media-gallery[data-desktop-layout="thumbnail_slider"]').forEach(initGallery);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
